<template>
    <div id="demo-basic-card">
        <vx-card class="mb-base">
            <div id="allTestsLoadingDiv" class="vs-con-loading__container">
                <div class="vx-row mb-base">
                    <div class="vx-col w-1/2">
                        <ul class="demo-alignment">
                            <li>
                                <vs-radio @change="searchQuestions()" v-model="lang" vs-value="all">All</vs-radio>
                            </li>
                            <li>
                                <vs-radio @change="searchQuestions()" v-model="lang" vs-value="da">Danish</vs-radio>
                            </li>
                            <li>
                                <vs-radio @change="searchQuestions()" v-model="lang" vs-value="en">English</vs-radio>
                            </li>
                        </ul>
                    </div>

                    <div class="vx-col w-1/2">
                        <vx-input-group class="mt-2">
                          <vs-input v-model="question_name" />

                          <template slot="append">
                            <div class="append-text btn-addon">
                              <vs-button @click="searchQuestions()" color="primary" type="filled" icon-pack="feather" icon="icon-search"></vs-button>
                            </div>
                          </template>
                        </vx-input-group>
                    </div>
                </div>

                <div class="vx-row p-4">
                    <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-if="testsData.length" v-for="(listItem, index) in testsData" :key="index">
                        <vx-card>
                            <div slot="no-body" class="imgHolder">
                                <img :src="listItem.picture" alt="content-img" class="responsive card-img-top">
                                <vs-chip class="ag-grid-cell-chip" color="primary">
                                  <span>{{ listItem.lang == 'da' ? "Danish" : "English" }}</span>
                                </vs-chip>
                            </div>
                            <h5 class="mb-2">{{ listItem.name }}</h5>
                            
                            <div class="flex justify-between flex-wrap">
                                <vs-button @click="editTest(listItem)"class="mt-4 shadow-lg" type="gradient" color="primary"  icon-pack="feather" icon="icon-edit" icon-after>Edit </vs-button>
                                <vs-button @click="deleteTest(listItem)"class="mt-4  shadow-lg" type="gradient" color="danger"  icon-pack="feather" icon="icon-archive" icon-after>Delete </vs-button>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'

export default{
    data() {
        return {
            testsData: [],
            totalPage: 1,
            currentPage: 1,
            question_name : null,
            lang : "all",
            deleteTestData : null,
        }
    },
    components: {
        VuePerfectScrollbar,
    },
    watch: {
        currentPage(val) {
            this.searchQuestions()
        }
    },
    mounted() {
        this.testsData = this.$store.state.questionManagement.tests
        this.getAllTests()
    },
    methods: {
        viewQuestion(question) {
            this.$router.push("/questions/view/" + question.id).catch(() => {})
        },
        editTest(test) {
            this.$router.push("/tests/edit/" + test.id).catch(() => {})
        },
        deleteTest(test) {
            this.deleteTestData = test;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this test data ?',
                accept: this.acceptDeleteTest
            })
        },
        acceptDeleteTest() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteTest", { id : this.deleteTestData.id})
                .then(res => { 
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Test deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => { 
                  this.$vs.loading.close()
                })
        },
        async searchQuestions() {
            var self = this
            this.$vs.loading({
                container: '#allTestsLoadingDiv',
                scale: 0.6
            })

            let data = { 
                lang : this.lang == "all" ? null : this.lang, 
                test_name : this.question_name, 
            }

            await this.$store.dispatch("questionManagement/getAllTests", data)
                .then(res => { 
                    this.testsData = res.data
                    this.$vs.loading.close('#allTestsLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.testsData = []
                    this.$vs.loading.close('#allTestsLoadingDiv > .con-vs-loading')
                })
        },
        getAllTests() {
            this.$vs.loading({
                container: '#allTestsLoadingDiv',
                scale: 0.6
            })

            this.$store.dispatch("questionManagement/getAllTests")
                .then(res => { 
                    this.testsData = res.data
                    this.$vs.loading.close('#allTestsLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.testsData = []
                    this.$vs.loading.close('#allTestsLoadingDiv > .con-vs-loading')
                })
        },
        viewPackage(module) {
            this.$router.push("/packages/view/" + module.id).catch(() => {})
        },
        editPackage(module) {
            this.$router.push("/packages/edit/" + module.id).catch(() => {})
        },
    },
    created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        this.testsData = this.$store.state.questionManagement.tests
        
    },

}
</script>
<style lang="css">
.imgHolder {
    position: relative;
}
.imgHolder div {
    position: absolute;
    right: 10px;
    top: 10px;
}
</style>

